// Single source of truth for the Rumio app manifest. Imported by:
//   - scripts/register-with-rumio.ts (publishes to Rumio admin)
//   - packages/api/src/lib/entitlements.ts (plan → entitlement lookup)
//   - packages/api/src/routes/me.routes.ts (exposes resolved entitlements to web)
//
// Mirrored to the platform manifest the user sees in the Rumio admin.
// Renumber/rename plans here, not in the script — keeping the data centralised
// prevents drift between what we publish and what the app enforces.
import { ManifestSchema, SUBSCRIBED_EVENTS, } from './rumio-types.js';
export const MANIFEST = ManifestSchema.parse({
    nav: [{ label: 'PodcastWiz', path: '/dashboard', icon: 'lucide:mic' }],
    entitlements: {
        free: {
            podcasts: 1,
            episodes_per_month: 4,
            ai_transcription_minutes: 60,
            ai_show_notes: false,
            ai_artwork: false,
            video_export: false,
            sponsorship_engine: false,
            max_team_members: 1,
        },
        pro: {
            podcasts: 5,
            episodes_per_month: null,
            ai_transcription_minutes: 1500,
            ai_show_notes: true,
            ai_artwork: true,
            video_export: true,
            sponsorship_engine: false,
            max_team_members: 5,
        },
        business: {
            podcasts: null,
            episodes_per_month: null,
            ai_transcription_minutes: 10000,
            ai_show_notes: true,
            ai_artwork: true,
            video_export: true,
            sponsorship_engine: true,
            hermes_simulator: true,
            max_team_members: 25,
        },
    },
});
export { SUBSCRIBED_EVENTS };
export const PLAN_SLUGS = Object.keys(MANIFEST.entitlements);
// The slug to apply when a tenant has no active subscription row. v1 policy:
// uninstalled or never-subscribed tenants get the free tier; webhooks lift
// them into pro/business as subscriptions activate.
export const DEFAULT_PLAN_SLUG = 'free';
// Entitlements for the default plan, as a typed record. Returned by
// resolveEntitlements() when neither the requested plan_slug nor the manifest
// know what to do.
export const DEFAULT_ENTITLEMENTS = MANIFEST.entitlements[DEFAULT_PLAN_SLUG] ?? {};
//# sourceMappingURL=manifest.js.map